// src/utils/sessionHandler.js

// Store the original fetch function
const originalFetch = window.fetch;

// Override the global fetch function
window.fetch = async (...args) => {
  try {
    // Call the original fetch
    const response = await originalFetch(...args);
    
    // Clone the response to read it (since response can only be read once)
    const clonedResponse = response.clone();
    
    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      try {
        const data = await clonedResponse.json();
        
        // Check for session expired error
        if (data.error === "Session expired, please login again") {
          handleSessionExpired();
          // Return a rejected promise to stop further processing
          return Promise.reject(new Error('Session expired'));
        }
      } catch (jsonError) {
        // If JSON parsing fails, just continue with original response
        console.log('Response is not valid JSON, continuing...');
      }
    }
    
    // Return the original response
    return response;
  } catch (error) {
    // Handle network errors or other fetch errors
    throw error;
  }
};

// Function to handle session expiration
const handleSessionExpired = () => {
  // Clear localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Show alert
  alert('Your session has expired. Please login again.');
  
  // Redirect to login page
  window.location.href = '/';
};

export default window.fetch;